import { memoize } from "lodash";
import { observable, runInAction } from "mobx";
import { TAdminResetPassword } from "../../../Types";
import getCoreUIStore from "../../core/core-ui-store";
import { apiCallGetAllAdmins } from "../../../api/core-api/api-call-get-all-admins";
import { reduce } from "et3-type-guards";
import getCorePopUpStore from "../../core/core-popup-store";
import { apiCallResetPassword } from "../../../api/supervisor-api/api-call-reset-password";

class ResetPasswordStore {
  activeAdmins = observable.box<TAdminResetPassword>([]);
  adminID = observable.box<number>(0);
  fullName = observable.box<string>("");
  generatedPassword = observable.box<string>("");

  setSelectedAdmin = (id: number, name: string) => {
    runInAction(() => {
      this.adminID.set(id);
      this.fullName.set(name);
    });
  };

  setActiveAdmins = (data: TAdminResetPassword) => {
    runInAction(() => {
      this.activeAdmins.set(data);
    });
  };

  setGeneratedPassword = (password: string) => {
    runInAction(() => {
      this.generatedPassword.set(password);
      getCorePopUpStore().alertAction.set("COPY");
    });
  };

  getActiveAdmins = async () => {
    getCoreUIStore().setIsLoading("SUPERVISOR_RESET_PASSWORDS", true);
    const { data, status } = await apiCallGetAllAdmins();
    getCoreUIStore().setIsLoading("SUPERVISOR_RESET_PASSWORDS", false);

    if (status === "OK") {
      const activeAdmins = reduce(() => data, []);
      this.setActiveAdmins(activeAdmins);
    }
  };

  resetAdminPassword = async () => {
    getCoreUIStore().setIsLoading("SUPERVISOR_RESET_PASSWORDS", true);
    const adminID = this.adminID.get();
    const { data, status, code } = await apiCallResetPassword({ adminID });
    getCoreUIStore().setIsLoading("SUPERVISOR_RESET_PASSWORDS", false);

    if (status === "OK") {
      this.setGeneratedPassword(data);
      getCorePopUpStore().showSuccessMessageWithExtraData(
        "NEW_GENERATED_PASSWORD",
        this.generatedPassword.get(),
        false
      );
    } else {
      getCorePopUpStore().showAlertMessage(code);
    }

    getCorePopUpStore().closeConfirmationPopUps();
  };
}

const getResetPasswordStore = memoize(
  () => new ResetPasswordStore(),
  () => 1
);
export default getResetPasswordStore;
